import type { WelfareFishCandidate } from '@scaleaq/sitecontrol-lib';

import { useTranslation } from 'react-i18next';

import { responsive } from '@/utils';

import { localizeObservationBreakdown } from './fishObservationGallery.functions.ts';
import { ObservationBreakdownBadges } from './ObservationBreakdownBadges.tsx';

type ImageHeadingProps = {
  observation: WelfareFishCandidate;
};

/**
 * Observation breakdown badges shown on gallery thumbnails when detections exist. Every detection
 * on the fish is shown, whatever the filter chips select — the chips only choose which fish appear.
 */
export const ImageHeading = ({ observation }: ImageHeadingProps) => {
  const { t } = useTranslation('orbitOne');

  const observationBreakdown = localizeObservationBreakdown({
    observation,
    t,
  });

  if (observationBreakdown.length === 0) return null;

  return (
    <ObservationBreakdownBadges
      entries={observationBreakdown}
      size='large'
      style={{
        position: 'absolute',
        inset: `${responsive.spacing['3xlarge']} ${responsive.spacing['3xlarge']} auto`,
      }}
    />
  );
};
